/*
 * @Description: 提现记录
 * @Author: gao shuai
 * @Date: 2020-05-14 09:27:03
 * @LastEditTime: 2020-05-23 17:20:06
 * @LastEditors: gao shuai
 */

import api from '../services/api';
export default {
  // 提现记录列表
  async withdrawList(params) {
    return api({ url: '/api/Settlements/GetSettlementLogListAsync', method: 'get', params });
  },
  // 提现详情
  async withdrawDetail(params) {
    return api({ url: '/api/Settlements/GetSettlementsDetailAsync', method: 'get', params });
  }
};
